import React, { useState, useEffect, useRef } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { withRouter } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { firestore, cloudFunctions } from "../../../firebase";
import {countries} from "../../../assets/country.json";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
  hidePostalCode: true,
};
const ChangePlans = ({ currentUser = {}, history = {} }) => {
  const title = "Select a Plan";

  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({ id: 0 });
  const [cardError, setCardError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [country, setCountry] = useState("");
  const [countryError, setCountryError] = useState(null);
  const [currentAccount, setCurrentAccount] = useState({})

  useEffect(() => {
    setLoading(true);

    const plansQuery = firestore.collection("plans").orderBy("price", "asc");
    plansQuery.get().then(async (planSnapShots) => {
      const snapshot = await firestore.collection("accounts").doc(currentUser.uid).get();
      if(!snapshot.exists){
        alert("Error Occurred");
        history.push("/profile")
      }else{
        setCurrentAccount({id: snapshot.id, ...snapshot.data()})
      }
      let p = [];
      planSnapShots.forEach((doc) => {
        p.push({
          id: doc.id,
          name: doc.data().name,
          price: doc.data().price,
          priceId: doc.data().priceId,
          currency: doc.data().currency,
          features: doc.data().features,
          stripePriceId: doc.data().stripePriceId,
        });
      });
      if (p.length > 0) {
        const ascendingOrderPlans = p.sort(
          (a, b) => parseFloat(a.price) - parseFloat(b.price)
        );
        setPlans(ascendingOrderPlans);
      }
      setLoading(false);
    });
  }, [currentUser]);

  const subcribe = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage(null);

    if (selectedPlan.price !== 0) {
      const createSubscription = cloudFunctions.httpsCallable(
        "createSubscription"
      );
      createSubscription({
        planId: selectedPlan.id,
        accountId: currentUser.uid,
      })
        .then((res) => {
          history.push("/profile/billing")
        })
        .catch((err) => {
          setLoading(false);
          setErrorMessage(err.message);
        });
    }
  };

  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 10000 }}>
        <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
      </Backdrop>
      <div className="container-fluid">
        <div className="animated fadeIn">
          <div className="card-deck mb-3">
            <div className="card">
              <div className="card-header text-center">
                <h3>{title}</h3>
              </div>
              <div className="card-body">
                <>
                  {errorMessage !== null && (
                    <Alert
                      severity="error"
                    >{errorMessage}</Alert>
                  )}
                  <div className="row justify-content-md-center">
                    <div className="col col-sm-12 col-md-8 col-lg-8 col-xl-8">
                      <div className="card-deck mb-5 text-center">
                        {plans.map((plan, i) => (
                          <div className="card" key={i + plan.id}>

                            <div className="card-header">
                              <h4 className="my-0 font-weight-normal">
                                {plan.name}
                              </h4>
                              <h1 className="card-title">
                                ${plan.price}
                                <small className="text-muted">
                                  {currentAccount.plan?.interval ? `/${currentAccount.plan?.interval}`:"month"}
                                </small>
                              </h1>
                            </div>
                            <div className="card-body">
                              <ul className="list-unstyled mt-3 mb-4">
                                {plan.features.map((feature, i) => (
                                  <li key={i}>
                                    <i className="fa fa-check text-success"></i>{" "}
                                    {feature}
                                  </li>
                                ))}
                              </ul>
                            </div>
                            <div className="card-footer bg-white">

                              {plan.priceId === currentAccount.plan.id ? (
                                <button
                                  type="button"
                                  className="btn btn-block btn-secondary"
                                  disabled={true}
                                >
                                  Current Plan
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className={
                                    plan.id !== selectedPlan.id
                                      ? "btn btn-block btn-outline-success"
                                      : "btn btn-block btn-success"
                                  }
                                  onClick={() => {
                                    for (let i = 0; i < plans.length; i++) {
                                      if (plans[i].id === plan.id) {
                                        setSelectedPlan(plan);
                                      }
                                    }
                                  }}
                                >
                                  {plan.id === selectedPlan.id && (
                                    <>
                                      <i className="fa fa-check"></i>{" "}
                                    </>
                                  )}
                                  {plan.id !== selectedPlan.id
                                    ? "Select"
                                    : "Selected"}
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                      {selectedPlan.id !== 0 && (
                        <button
                          className="btn btn-lg btn-block btn-primary"
                          disabled={
                            selectedPlan.id === 0 || loading
                              ? true
                              : false
                          }
                          onClick={(e) => {
                            subcribe(e);
                          }}
                        >
                          Subscribe
                        </button>
                      )}
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ChangePlans);
